import type TableView from "../store/schema/TableView";

/**
 * Clears both row-key and group-header selection on a table view.
 */
export default function clearSelection(tableView: TableView): void {
    tableView.selectedRowKeys.clear();
    tableView.selectedGroupHeaders.clear();
}
